<mat-card appearance="outlined">
  <mat-card-content class="no-title" [formGroup]="spesenForm">
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "HOME.Spesen" | translate }}</mat-label>
        <mat-select formControlName="spesen">
          <mat-option *ngFor="let item of spesenModel" [value]="item.description">
            {{ item.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="row">
      <mat-form-field>
        <mat-label> {{ "HOME.Menge" | translate }} </mat-label>
        <input type="number" matInput placeholder="{{ 'HOME.Menge' | translate }}" formControlName="menge" />
      </mat-form-field>
    </span>
    <span class="row">
      <mat-form-field>
        <mat-label> {{ "HOME.Betrag" | translate }} </mat-label>
        <input type="number" matInput placeholder="{{ 'HOME.Betrag' | translate }}" formControlName="betrag" />
      </mat-form-field>
    </span>
  </mat-card-content>
  <mat-dialog-actions>
	  <button (click)="next()" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
